import React from "react";

export default function MySQL_EXP() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_EXP</h1>
      <p>This is the MySQL_EXP component generated from the SQL JSON.</p>
    </div>
  );
}
